export const SUPPORTED_FACING_MODES = ["user", "environment"] as const;
export type FacingMode = (typeof SUPPORTED_FACING_MODES)[number];

export const FACING_MODES = {
	USER: "user",
	ENVIRONMENT: "environment",
} as const;

export const SUPPORTED_IMAGE_TYPES = ["jpg", "png"] as const;
export type ImageType = (typeof SUPPORTED_IMAGE_TYPES)[number];

export const IMAGE_TYPES = {
	PNG: "png",
	JPG: "jpg",
} as const;

export const FORMAT_TYPES: Record<ImageType, string> = {
	jpg: "image/jpeg",
	png: "image/png",
};

export const NO_CONSTRAINTS: MediaStreamConstraints = {
	audio: false,
	video: true,
};
